/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_CenterInputs */

const en_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command Center`)
};

const es_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de mando`)
};

const fr_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de commandement`)
};

const de_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommandozentrale`)
};

const ja_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンドセンター`)
};

const zh_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指挥中心`)
};

const ar_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز القيادة`)
};

const id_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Komando`)
};

const it_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di Comando`)
};

const ru_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командный центр`)
};

const pt_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Comando`)
};

const ko_command_center = /** @type {(inputs: Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커맨드 센터`)
};

/**
* | output |
* | --- |
* | "Command Center" |
*
* @param {Command_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const command_center = /** @type {((inputs?: Command_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_command_center(inputs)
	if (locale === "es") return es_command_center(inputs)
	if (locale === "fr") return fr_command_center(inputs)
	if (locale === "de") return de_command_center(inputs)
	if (locale === "ja") return ja_command_center(inputs)
	if (locale === "zh") return zh_command_center(inputs)
	if (locale === "ar") return ar_command_center(inputs)
	if (locale === "id") return id_command_center(inputs)
	if (locale === "it") return it_command_center(inputs)
	if (locale === "ru") return ru_command_center(inputs)
	if (locale === "pt") return pt_command_center(inputs)
	return ko_command_center(inputs)
});